import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOMeta from "@/components/SEOMeta";
import LocalBusinessSchema from "@/components/LocalBusinessSchema";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Home, Wrench, Zap, Droplet, Wind, Phone, Mail, MapPin } from "lucide-react";

const StCatharines = () => {
  const services = [
    { title: "Carpentry Services", icon: Home, link: "/services/carpenter" },
    { title: "Electrical Services", icon: Zap, link: "/services/electrician" },
    { title: "Plumbing Services", icon: Droplet, link: "/services/plumber" },
    { title: "HVAC Services", icon: Wind, link: "/services/hvac" },
    { title: "Roofing Services", icon: Home, link: "/services/roofing" },
    { title: "General Contracting", icon: Wrench, link: "/services/general-contracting" }
  ];

  return (
    <>
      <SEOMeta 
        title="General Contractor in St. Catharines — Residential & Commercial"
        description="Local general contracting and skilled trades in St. Catharines. Carpentry, electrical, plumbing, HVAC, roofing and more — trusted, licensed and insured."
        keywords="general contractor St. Catharines, St. Catharines construction, contractor near me, carpentry, electrician, plumber, HVAC, roofing"
        canonicalUrl="https://blueknightcontracting.ca/st-catharines"
      />
      
      <LocalBusinessSchema 
        locationName="St. Catharines"
        addressLocality="St. Catharines"
        addressRegion="ON"
        postalCode="L2R"
        description="Professional general contracting and skilled trades in St. Catharines. Licensed contractors for carpentry, electrical, plumbing, HVAC, roofing and complete construction services."
        services={[
          "General Contracting",
          "Carpentry Services",
          "Electrical Services",
          "Plumbing Services",
          "HVAC Services",
          "Roofing Services"
        ]}
      />
      
      <div className="min-h-screen bg-background">
        <Header />
        
        <section className="relative bg-gradient-to-br from-primary to-primary/80 text-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <h1 className="text-4xl lg:text-6xl font-bold mb-6">
                General Contractor in St. Catharines
              </h1>
              <p className="text-xl mb-8 opacity-90">
                Local general contracting and skilled trades in St. Catharines. Carpentry, electrical, plumbing, HVAC, roofing and more — trusted, licensed and insured.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button asChild size="lg" variant="secondary">
                  <Link to="/contact">Get Free Quote</Link>
                </Button>
                <Button asChild size="lg" variant="outline" className="bg-white/10 text-white border-white/20 hover:bg-white/20">
                  <Link to="/services">View All Services</Link>
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl lg:text-4xl font-bold mb-6">
                Our Services in St. Catharines
              </h2>
              <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
                Professional construction and renovation services for St. Catharines homes and businesses
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <Card key={index} className="h-full hover:shadow-lg transition-shadow">
                  <CardHeader>
                    <service.icon className="h-12 w-12 text-primary mb-4" />
                    <CardTitle>{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <Button asChild variant="link" className="px-0">
                      <Link to={service.link}>Learn More →</Link>
                    </Button>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 bg-primary text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl lg:text-4xl font-bold mb-6">
              Need a Contractor in St. Catharines?
            </h2>
            <p className="text-xl mb-8 opacity-90 max-w-3xl mx-auto">
              Contact Blue Knight Contracting for professional construction services in St. Catharines. Licensed, insured and locally trusted.
            </p>
            <Button asChild size="lg" variant="secondary">
              <Link to="/contact">Get Free Quote Today</Link>
            </Button>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default StCatharines;
